<button class="inline-flex font-semisbold leading-relaxed items-center" type="button">
  <ng-content></ng-content>
  @if (isCreate) {
  <app-icon class="ml-2" name="plus" size="medium"></app-icon>
  } @else {
  <ng-content select="[icon]"></ng-content>
  }
</button>
